import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "content__title" }, " Profile ", -1)
const _hoisted_2 = {
  key: 0,
  class: "profile"
}

import WalletChart from '@/components/WalletChart.vue'
import WalletProfile from '@/components/WalletProfile.vue'
import ElementLoader from '@/components/UI/ElementLoader.vue'
import { useLoading } from '@/hooks/useLoading'


export default /*#__PURE__*/_defineComponent({
  name: 'Profile',
  setup(__props) {

const { isLoading } = useLoading()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_unref(isLoading))
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(WalletChart),
          _createVNode(WalletProfile)
        ]))
      : (_openBlock(), _createBlock(ElementLoader, { key: 1 }))
  ], 64))
}
}

})